<template>
    <div class="modal fade" id="dialogModal" tabindex="-1" aria-labelledby="dialogModalLabel" aria-hidden="false" ref="openDialogBtnRef">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
        <div class="modal-header py-2">
            <h1 class="modal-title fs-6" id="dialogModalLabel">{{ modalSetting.modalNm }}</h1>
            <ElButton type="modelHeaderClose"></ElButton>
        </div>
        <div class="modal-body py-4">
            <p class="mb-0">{{ modalSetting.msg }}</p>
        </div>
        <div class="modal-footer py-2">
            <ElButton v-if="modalSetting.type === 'confirm'" type="modelFooterConfirm"  @buttonClick="confirm()">확인</ElButton>
            <ElButton type="modelFooterClose"  @buttonClick="cancel()">닫기</ElButton>
        </div>

        </div>
    </div>
    </div>

</template>
   
<script setup>
import {ref,onMounted} from 'vue'


let dialog
const openDialogBtnRef = ref()
// Promise 객체를 핸들링하기 위한 ref
const resolvePromise = ref(null);

const modalSetting = ref({
    type : '',
    modalNm : '',
    msg : ''
})


onMounted(()=>{
    dialog = new bootstrap.Modal(openDialogBtnRef.value);
})

//dialog open
function openDialog(type,msg){
    switch(type) {
        case 'alert':
            modalSetting.value.type = 'alert'
            modalSetting.value.modalNm = 'Alert'
            modalSetting.value.msg = msg
            break;
        case 'confirm':
            modalSetting.value.type = 'confirm'
            modalSetting.value.modalNm = 'Confirm'
            modalSetting.value.msg = msg
            break;
        default:
            modalSetting.value.type = 'dialog'
            modalSetting.value.modalNm = 'Dialog'
            modalSetting.value.msg = ''
            break;
    }
    dialog.show();
    // const {Promise,reject,resolve} = Promise.with
    return new Promise((resolve) => {
        resolvePromise.value = resolve;
    });
}

//모달창 닫기버튼 클릭
const cancel = ()=>{
    dialog.hide()
    resolvePromise.value(false);
}

//모달창 확인버튼 클릭
const confirm = () => {
    dialog.hide()
    resolvePromise.value(true);
}


defineExpose({
    openDialog
})


</script>
   